import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Specialty from './pages/Specialty';
import OurTeam from './pages/OurTeam';
import Testimonials from './pages/Testimonials';
import ContactUs from './pages/ContactUs';
import FloatingButtons from './components/FloatingButtons';

function App() {
  return (
    <Router>
      <div className="App">
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/specialty" element={<Specialty />} />
            <Route path="/team" element={<OurTeam />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/contact" element={<ContactUs />} />
          </Routes>
        </Layout>
        <FloatingButtons />
      </div>
    </Router>
  );
}

export default App;
